import { render, staticRenderFns } from "./PrepProcessIndex.vue?vue&type=template&id=6fa87902"
import script from "./PrepProcessIndex.vue?vue&type=script&lang=js"
export * from "./PrepProcessIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports